import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
    //列表
    adjustList: (data) => apiAxios('post', baseURL + '/adjust.list', data),
    //新增
    adjustStore: (data) => apiAxios('post', baseURL + '/adjust.store', data),
    //修改
    adjustUpdate: (data) => apiAxios('post', baseURL + '/adjust.update', data),
    //删除
    adjustDelete: (data) => apiAxios('post', baseURL + '/adjust.delete', data),
    //确认
    adjustConfirm: (data) => apiAxios('post', baseURL + '/adjust.confirm', data),
}